if (!customElements.get('starpatch-kit-gallery')) {
  customElements.define(
    'starpatch-kit-gallery',
    class extends HTMLElement {
      connectedCallback() {
        this.image = this.querySelector('[data-gallery-image]');
        this.controls = this.querySelector('.sp-gallery__controls');
        if (!this.image || !this.controls) return;
        this.selectImage = this.selectImage.bind(this);
        this.controls.addEventListener('click', this.selectImage);
        this.controls.hidden = false;
      }

      disconnectedCallback() {
        this.controls?.removeEventListener('click', this.selectImage);
      }

      selectImage(event) {
        const button = event.target.closest('button[data-image]');
        if (!button || !this.controls.contains(button)) return;
        if (button.dataset.srcset) this.image.srcset = button.dataset.srcset;
        else this.image.removeAttribute('srcset');
        this.image.src = button.dataset.image;
        this.image.alt = button.dataset.alt;
        this.image.width = Number(button.dataset.width);
        this.image.height = Number(button.dataset.height);
        this.querySelectorAll('button[data-image]').forEach(control => {
          control.setAttribute('aria-pressed', String(control === button));
        });
      }
    }
  );
}

if (!customElements.get('starpatch-purchase-link')) {
  customElements.define(
    'starpatch-purchase-link',
    class extends HTMLElement {
      connectedCallback() {
        this.refresh = this.refresh.bind(this);
        this.navigate = this.navigate.bind(this);
        this.addEventListener('click', this.navigate);
        document.addEventListener('shopify:section:load', this.refresh);
        this.refresh();
      }

      disconnectedCallback() {
        this.observer?.disconnect();
        this.removeEventListener('click', this.navigate);
        document.removeEventListener('shopify:section:load', this.refresh);
        document.body.classList.remove('sp-has-sticky-link');
      }

      refresh() {
        this.observer?.disconnect();
        this.hidden = true;
        document.body.classList.remove('sp-has-sticky-link');
        this.target = document.getElementById('StarpatchPurchase');
        const submit = document.querySelector('product-info[id^="MainProduct-"] .product-form__submit');
        if (!this.target || !submit || !('IntersectionObserver' in window)) return;

        this.observer = new IntersectionObserver(
          ([entry]) => {
            this.hidden = entry.isIntersecting;
            document.body.classList.toggle('sp-has-sticky-link', !this.hidden);
          },
          { threshold: 0 }
        );
        this.observer.observe(submit);
      }

      navigate(event) {
        if (!event.target.closest('a[href="#StarpatchPurchase"]') || !this.target) return;
        event.preventDefault();
        this.target.scrollIntoView({
          behavior: window.matchMedia('(prefers-reduced-motion: reduce)').matches ? 'instant' : 'smooth',
          block: 'start',
        });
        this.target.focus({ preventScroll: true });
      }
    }
  );
}
